import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Globals} from '../../global/globals';
import {Observable} from 'rxjs';
import {SystemicGrammarCategoryDto} from '../../dtos/grammar/sys/systemic-grammar-category-dto';
import {SystemicGrammarEntryPageDto} from '../../dtos/grammar/sys/systemic-grammar-entry-page-dto';
import {SystemicGrammarCategoryPageDto} from "../../dtos/grammar/sys/systemic-grammar-category-page-dto";
import {SystemicGrammarEntryDto} from "../../dtos/grammar/sys/systemic-grammar-entry-dto";
import {SharedService} from "../common/shared.service";

@Injectable({
  providedIn: 'root'
})
export class SysGrammarService {

  private systemicGrammarBaseUri: string = this.globals.backendUri + '/grammar/systemic';

  constructor(private httpClient: HttpClient, private globals: Globals, private sharedService: SharedService) {
  }

  /* -------------------- Entry -------------------- */

  searchEntries(params: HttpParams): Observable<SystemicGrammarEntryPageDto> {
    return this.httpClient.get<SystemicGrammarEntryPageDto>(this.systemicGrammarBaseUri + '/entries', {params});
  }

  createEntry(newEntry): Observable<SystemicGrammarEntryDto> {
    return this.httpClient.post<SystemicGrammarEntryDto>(this.systemicGrammarBaseUri + '/entries', newEntry);
  }

  updateEntry(newEntry): Observable<SystemicGrammarEntryDto> {
    return this.httpClient.put<SystemicGrammarEntryDto>(this.systemicGrammarBaseUri + '/entries/' + newEntry.id, newEntry);
  }

  getEntry(id: number): Observable<SystemicGrammarEntryDto> {
    return this.httpClient.get<SystemicGrammarEntryDto>(this.systemicGrammarBaseUri + '/entries/' + id)
  }

  deleteEntry(id: number): Observable<void> {
    return this.httpClient.delete<void>(this.systemicGrammarBaseUri + '/entries/' + id)
  }

  /* -------------------- Category -------------------- */

  getRootCategories(): Observable<SystemicGrammarCategoryDto[]> {
    return this.httpClient.get<SystemicGrammarCategoryDto[]>(this.systemicGrammarBaseUri + '/categories/roots');
  }

  searchCategories(params: HttpParams): Observable<SystemicGrammarCategoryPageDto> {
    return this.httpClient.get<SystemicGrammarCategoryPageDto>(this.systemicGrammarBaseUri + '/categories', {params});
  }

  createCategory(newCategory): Observable<SystemicGrammarCategoryDto> {
    return this.httpClient.post<SystemicGrammarCategoryDto>(this.systemicGrammarBaseUri + '/categories', newCategory);
  }

  updateCategory(category): Observable<SystemicGrammarCategoryDto> {
    return this.httpClient.put<SystemicGrammarCategoryDto>(this.systemicGrammarBaseUri + '/categories/' + category.id, category);
  }

  getCategoryByID(id: number): Observable<SystemicGrammarCategoryDto> {
    return this.httpClient.get<SystemicGrammarCategoryDto>(this.systemicGrammarBaseUri + '/categories/' + id);
  }

  deleteCategory(id: number): Observable<any> {
    return this.httpClient.delete<any>(this.systemicGrammarBaseUri + '/categories/' + id);
  }

  /* -------------------- Other -------------------- */

  updateExplanation(id: number, s: string): Observable<string> {
    return this.httpClient.put(this.systemicGrammarBaseUri + '/categories/' + id + '/explanation', s, {responseType: 'text'});
  }

  getCategoryExplanation(id: number): Observable<string> {
    return this.httpClient.get(this.systemicGrammarBaseUri + '/categories/' + id + '/explanation', {responseType: 'text'});
  }

  getEntryAsArray(entry: SystemicGrammarEntryDto) {
    const tmpEntries = this.sharedService.filterNullOrEmpty(this.sharedService.extractReferences(entry));
    const entries = [];
    for (const tmpEntry of tmpEntries) {
      if (tmpEntry[0] !== 'id' && tmpEntry[0] !== 'name' && tmpEntry[0] !== 'receptive') {
        if (tmpEntry[0] === 'category') {
          tmpEntry[0] = 'Themenbaum'
          tmpEntry[1] = this.sharedService.getCategoryTree(tmpEntry[1]);
        } else if (tmpEntry[0] === 'productive') {
          tmpEntry[0] = 'Niveau'
        } else if (tmpEntry[0] === 'example') {
          tmpEntry[0] = 'Beispiel'
        } else if (tmpEntry[0] === 'comment') {
          tmpEntry[0] = 'Kommentar'
        }
        entries.push(tmpEntry)
      }
    }
    return entries
  }
}
